module.exports = __webpack_public_path__ + "assets/energy.f8385631.svg";